<template>
  <div class="field-container" v-bind:class="customClass">
    <div class="row">
      <input
        v-cypress="testId"
        :type="type"
        :disabled="disabled"
        :id="id"
        class="form-input"
        :class="{ isValid: !isValid }"
        :v-bind:class="customClass"
        v-validate="validate !== '' ? validate : false"
        :ref="id"
        :name="id"
        :value="value"
        @input="$emit('input', $event.target.value)"
        v-cleave="cleave"
        :placeholder="$t(`forms.${placeholder}`)"
        data-vv-validate-on="change,input,update"
      />
    </div>
    <!-- Helper -->
    <!-- <span v-if="this.label == 'birthday'" class="form-error birthday">{{ $t(`forms.helps.${label}`) }}</span> -->
    <!-- Error messages -->
    <!-- <span class="form-error">{{ errors.first(id) }}</span> -->
  </div>
</template>

<script>
export default {
  name: 'VvFormMaskInput',
  computed: {
    showAsterisk() {
      if ((this.validate && this.validate.indexOf('required') !== -1) || this.label == 'birthday') {
        return '*'
      }

      return ''
    },
    formErrors: function() {
      return this.$validator.errors
    }
  },
  data: () => ({
    isValid: true
  }),
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String
    },
    validate: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    testId: {
      type: String,
      default: null
    },
    cleave: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  inject: ['$validator'],
  watch: {
    value: async function(val) {
      if (this.validate === '') {
        this.isValid = val !== ''
      } else {
        this.isValid = (await this.$validator.verify(val, this.validate)).valid
      }
    },
    formErrors: {
      handler: function(value) {
        if (!!this.$validator.errors.first(this.id) == false) {
          this.isValid = true
        } else {
          this.isValid = false
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.form-input {
  height: 25px;
  border-radius: 7px;
  background-color: #ffffff;
  padding: 9px 13px;
  margin: 1px;
  margin-bottom: 10px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  font-family: $font-family-splash;
  width: 100%;
  // font-stretch: normal;
  // line-height: normal;
  // letter-spacing: normal;
  color: $font-color;
  border: none;
}

.form-input:focus {
  outline: solid 2px $primary;
}

.form-label {
  text-align: left;
  margin-bottom: 6px;
}

.valid-field {
  float: right;
  height: 14px;
  object-fit: contain;
  padding: 10px 10px 10px 10px;
}

.row {
  display: flex;
}

.field-container {
  display: flex;
  flex-direction: column;
  width: 98%;
}

.form-error {
  display: block;
  color: red;
  margin-top: 4px;
  font-size: 10px;
  text-align: left;
}

.birthday {
  color: #2d2d2d;
}

.cartInformationsVariant {
  width: 100%;
  margin-top: 10px;
  background-color: white;
  border-radius: 0;

  .valid-field {
    display: none;
  }

  .form-input {
    border: 2px solid #979a9a;
  }
}

.isValid {
  outline: solid 1px red;
}

@media all and (max-width: 620px) {
  form-input {
    height: 25px;
    border-radius: 7px;
    background-color: #ffffff;
    padding: 9px 13px;
    margin: 1px;
    margin-bottom: 10px;
    font-family: Avenir;
    font-size: 16px;
    font-weight: 500;
    font-family: $font-family-splash;
    width: 100%;
    // font-stretch: normal;
    // line-height: normal;
    // letter-spacing: normal;
    color: $font-color;
    border: none;
  }

  .field-container {
    display: flex;
    flex-direction: column;
    width: 68.5%;
  }
}
</style>
